import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Autocomplete, Box, Checkbox, FormControlLabel, IconButton, Tooltip } from "@mui/material"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { findServiceOrderItemType, useServiceOrderItemTypes } from "../../ReactQuery/QueryServiceOrderItemTypes"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

export default function CustomerItemModal({
    customerItem,
    open,
    closeModal,
    creatingNewCustomerItem,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const { data: serviceOrderItemTypes } = useServiceOrderItemTypes();
    const [myCustomerItem, setMyCustomerItem] = React.useState(customerItem || {})

    React.useEffect(() => {
        setMyCustomerItem(customerItem)
    }, [customerItem])

    const handleChange = (prop) => (event, sometimes_new_value) => {
        if (prop === "service_order_item_type_id") {
            setMyCustomerItem({
                ...myCustomerItem,
                [prop]: sometimes_new_value.id,
                extra_attrs: sometimes_new_value.id === customerItem?.[prop] ? customerItem?.extra_attrs : {}
            })
        } else if (prop === "purchase_date") {
            setMyCustomerItem({
                ...myCustomerItem,
                [prop]: event,
            })
        } else if (prop === "purchased_from_us") {
            setMyCustomerItem({
                ...myCustomerItem,
                [prop]: event.target.checked,
            })
        } else {
            setMyCustomerItem({
                ...myCustomerItem,
                [prop]: event.target.value,
            })
        }
    }
    const handleExtraAttrChange = (prop) => (event) => {
        setMyCustomerItem({
            ...myCustomerItem,
            extra_attrs: { ...myCustomerItem.extra_attrs, [prop]: event.target.value },
        })
    }

    const save = (event) => {
        delete myCustomerItem.date_created
        delete myCustomerItem.date_updated
        if (creatingNewCustomerItem || myCustomerItem.id === -1) {
            closeModal(myCustomerItem)
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `customeritems/${myCustomerItem.id}`,
                    myCustomerItem
                ).then(() => {
                    enqueueSnackbar('Successfully updated customer item', { variant: 'success' })
                    closeModal(true)
                }
                )
            )
        }
    }
    const deleteCustomerItem = () => {
        // console.log('delete customer item')
        // send_authorized_request(() =>
        //     AXIOS_API_INSTANCE.delete(`rentalcategories/${myCustomerItem.id}`).then(
        //         axios.spread(() => {
        //             enqueueSnackbar('Successfully deleted category', { variant: 'success' })
        //             closeModal(true)
        //         })
        //     )
        // )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>{creatingNewCustomerItem ? "Creating Customer Item" : "Modifying Customer Item"}</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container alignItems={'center'}>
                        <Grid size={12}>
                            <TextField
                                margin="dense"
                                id="manufacturer"
                                label="Manufacturer"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={myCustomerItem.manufacturer || ""}
                                onChange={handleChange("manufacturer")}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                margin="dense"
                                id="model"
                                label="Model"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={myCustomerItem.model || ""}
                                onChange={handleChange("model")}
                            />
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                margin="dense"
                                id="identifier"
                                label="Identifier"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={myCustomerItem.identifier || ""}
                                onChange={handleChange("identifier")}
                            />
                        </Grid>
                        <Grid size={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Purchase Date"
                                    value={myCustomerItem.purchase_date ? dayjs.utc(myCustomerItem.purchase_date) : null}
                                    onChange={handleChange("purchase_date")}
                                    slotProps={{
                                        field: {
                                            clearable: true, onClear: () => setMyCustomerItem({
                                                ...myCustomerItem,
                                                purchase_date: null,
                                            })
                                        },
                                    }}
                                    sx={{ mt: 1, mb: 1 }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={6} alignItems={'center'} sx={{ verticalAlign: 'center' }}>
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={myCustomerItem.purchased_from_us || false}
                                            onChange={handleChange("purchased_from_us")}
                                        />
                                    }
                                    label="Purchased From Us"
                                />
                            </Box>
                        </Grid>
                        {(findServiceOrderItemType(serviceOrderItemTypes, myCustomerItem.service_order_item_type_id)?.extra_attrs ?? []).map((attr) =>
                            <Grid size={12}>
                                <TextField
                                    key={attr}
                                    margin="dense"
                                    id={attr}
                                    label={attr}
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={myCustomerItem?.extra_attrs?.[attr] || ""}
                                    onChange={handleExtraAttrChange(attr)}
                                />
                            </Grid>
                        )}
                        <Grid size={12}>
                            <Box width={"100%"} sx={{ pt: 1 }}>
                                <Autocomplete
                                    sx={{ color: 'rgba(0, 0, 0, 0.6)' }}
                                    getOptionLabel={(option) => `${option.name || ""}`}
                                    options={serviceOrderItemTypes.sort((a, b) => a.name.localeCompare(b.name))}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    autoComplete
                                    includeInputInList
                                    disableClearable
                                    value={findServiceOrderItemType(serviceOrderItemTypes, myCustomerItem.service_order_item_type_id) ?? ''}
                                    noOptionsText="No Item Types"
                                    onChange={handleChange("service_order_item_type_id")}
                                    required
                                    renderInput={(params) => {
                                        return (<TextField {...params} label="Service Item Type" required fullWidth autoComplete='off' />)
                                    }}
                                    renderOption={(props, option, { inputValue }) => {
                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                        const parts = parse(props.key, matches);
                                        const li_props = { ...props }
                                        delete li_props.key

                                        return (
                                            <li {...li_props} key={props.id}>
                                                <div>
                                                    {parts.map((part, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                fontWeight: part.highlight ? 700 : 400,
                                                            }}
                                                        >
                                                            {part.text}
                                                        </span>
                                                    ))}
                                                </div>
                                            </li>
                                        );
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid>
                            {!creatingNewCustomerItem &&
                                <Tooltip title={myCustomerItem.deletable_reason}>
                                    <span> {/* span required for tooltip events */}
                                        <Button disabled={!myCustomerItem.deletable} variant='outlined' color='error' onClick={deleteCustomerItem} sx={{ mr: 1 }}>
                                            <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                        </Button>
                                    </span>
                                </Tooltip>
                            }
                        </Grid>
                        <Grid>
                            <Button variant="contained" autoFocus onClick={save} disabled={myCustomerItem.service_order_item_type_id === undefined}>
                                {creatingNewCustomerItem ? "Create" : "Save"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog >
        </div >)
    );
}
